/**
 * Ensures all clickable links (a[href]) and buttons (button) on blog and article pages have valid aria-label attributes.
 */
function ensureBlogAndArticleAriaLabels() {
  const isBlogOrArticle =
    document.body.classList.contains('template-blog') ||
    document.body.classList.contains('template-article') ||
    document.querySelector('blog-posts-list, .blog-posts, .main-blog-post, .blog-post-content') !== null;

  if (!isBlogOrArticle) return;

  const clickables = document.querySelectorAll('a[href], button, [role="button"]');

  clickables.forEach((el) => {
    const existingLabel = el.getAttribute('aria-label');
    if (existingLabel && existingLabel.trim().length > 0) {
      return;
    }

    let label = el.textContent ? el.textContent.trim() : '';

    if (!label) {
      label = el.getAttribute('title') ? el.getAttribute('title').trim() : '';
    }

    if (!label) {
      const img = el.querySelector('img');
      if (img && img.getAttribute('alt')) {
        label = img.getAttribute('alt').trim();
      }
    }

    if (!label) {
      if (el.tagName.toLowerCase() === 'a') {
        const href = el.getAttribute('href') || '';
        if (href.includes('youtube') || href.includes('vimeo')) {
          label = 'Watch video';
        } else if (href.includes('facebook') || href.includes('twitter') || href.includes('instagram')) {
          label = 'Social link';
        } else {
          label = 'Article link';
        }
      } else {
        label = 'Interactive button';
      }
    }

    if (label) {
      el.setAttribute('aria-label', label);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ensureBlogAndArticleAriaLabels);
} else {
  ensureBlogAndArticleAriaLabels();
}

const observer = new MutationObserver(() => {
  ensureBlogAndArticleAriaLabels();
});

if (document.body) {
  observer.observe(document.body, { childList: true, subtree: true });
}
